//付款定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 类型
 */
class Type extends UltMeta {
    DOWNSTREAM_UPSTREAM = new Meta(1, "下游采购商-供应商");
    DOWNSTREAM_MIDSTREAM = new Meta(2, "下游采购商-联合采购商");
    MIDSTREAM_UPSTREAM = new Meta(3, "联合采购商-供应商");
}

export const TYPE = new Type();

/**
 * 状态
 */
class State extends UltMeta {
    CONFIRMING = new Meta(1, "确认中");
    FINISHED = new Meta(2, "已完成");
    REJECTED = new Meta(3, "已驳回");
    INVALIDING = new Meta(4, "作废中");
    INVALID = new Meta(5, "已作废");
}

export const STATE = new State();
